import utils from '@src/common/utils'
import {
  Dic
} from '@src/common/utils'
const detailOption = function () {
  return {
    add: '新增',
    edit: '修改',
    view: '查看',
    page: true,
    selection: false,
    index: false,
    indexLabel: '序号',
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewFormSlot: true,
    labelSuffix: '：',
    size: 'small',
    maxHeight: '100%',
    labelWidth: '140px',
    menuAlign: 'center',
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 200,
    dialogWidth: '450px',
    emptyText: '暂无数据',
    column: [{
        label: '授权道闸组',
        prop: 'thirdDeviceName',
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        overHidden: true,
        search: false,
      },
      {
        label: '通行生效时间',
        prop: 'effectiveTime',
        search: false,
        overHidden: true,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        align: 'right',
        type: 'datetime',
        columnWidth: '150px',
        span: 12,
        rules: [{
          required: true,
          message: "请选择通行生效时间",
          trigger: "blur",
        }, ],
        formatter: function (row, value) {
          return value ? utils.Dates.dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '';
        }
      },
      {
        label: '通行失效时间',
        prop: 'expirationTime',
        value: '',
        search: false,
        overHidden: true,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        align: 'right',
        type: 'datetime',
        columnWidth: '150px',
        span: 12,
        rules: [{
          required: true,
          message: "请选择通行失效时间",
          trigger: "blur",
        }, ],
        formatter: function (row, value) {
          return value ? utils.Dates.dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '';
        }
      },
      {
        label: '授权',
        prop: 'authStatus',
        type: 'select',
        search: false,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        span: 12,
        dicData: [{
            label: '失效',
            value: '2'
          },
          {
            label: '已授权',
            value: '1'
          }
        ],
        viewFormatter: (row, value) => {
          if (Number(value) === 1) {
            return '已授权'
          } else if (Number(value) === 2) {
            return '失效'
          }
          return '';
        },
        formatter: (row, value) => {
          if (Number(value) === 1) {
            return '已授权'
          } else if (Number(value) === 2) {
            return '失效'
          }
          return '';
        },
      },
      {
        label: '授权时间',
        prop: 'createTime',
        value: '',
        overHidden: true,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        align: 'right',
        type: 'datetime',
        columnWidth: '150px',
        span: 12,
        rules: [{
          required: true,
          message: "请选择通行失效时间",
          trigger: "blur",
        }, ],
        formatter: function (row, value) {
          return value ? utils.Dates.dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '';
        }
      },
      {
        label: '授权渠道',
        prop: 'authChannel',
        search: false,
        searchSlot: false,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        span: 12,
        align: 'center',
        dicData: Dic.find('SENU104001'),
        viewFormatter: (row, value) => {
          if (value) {
            return Dic.findByValue('SENU104001', Number(value))
          }
          return ''
        },
        formatter: function (row, value) {
          return value ? Dic.findByValue('SENU104001', value) : ''
        },
      },
      {
        label: '授权人',
        prop: 'creatorName',
        search: false,
        searchSlot: false,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
      },
    ]
  }
}
export default detailOption